<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px">
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="title">基本信息</div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select disabled v-model="form.nursinghomeId" style="width: 100%" placeholder="请选择服务网点"
                @change="nursinghomeIdChange">
                <el-option v-for="item in nursinghomeIdList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


          <el-col :span="8">
            <el-form-item label="老人姓名" prop="name">
              <el-input :disabled="model === 'view'" v-model="form.name" placeholder="请输入老人姓名"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="老人分类" prop="categoryTagList">
              <el-select :disabled="model === 'view'" collapse-tags v-model="form.categoryTagList" multiple
                placeholder="请选择老人分类" style="width:100%">
                <el-option v-for="item in categoryTagsList" :key="item.dictKey" :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="身份证号" prop="idNumber">
              <el-input clearable :disabled="model === 'view'" v-model="form.idNumber" placeholder="请输入身份证号"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出生日期" prop="birthday">
              <el-date-picker @change="birthdayChange" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="model === 'view'" v-model="form.birthday" type="date" placeholder="请选择出生日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="年龄" prop="age">
              <el-input readonly :disabled="model === 'view'" v-model="form.age" placeholder="请输入年龄"
                maxlength="100"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="生存状态" label-width="110px" prop="isExistence">
              <el-select v-model="form.isExistence" style="width: 100%" placeholder="请选择生存状态"
                :disabled="model === 'view'">
                <el-option v-for="item in isExistenceList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="性别" prop="sex">
              <el-radio-group :disabled="model === 'view'" v-model="form.sex">
                <!-- <el-radio :label="'1'">{{}}</el-radio> -->
                <el-radio v-for="(item, index) in sexList" :key="index" :label="item.dictKey">{{ item.dictValue
                  }}</el-radio>

              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="服务需求" prop="serviceNeedTagList">
              <el-select :disabled="model === 'view'" collapse-tags v-model="form.serviceNeedTagList" multiple
                placeholder="请选择服务需求" style="width:100%">
                <el-option v-for="item in needTagsList" :key="item.dictKey" :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="健康状态" label-width="110px" prop="healthStatus">
              <el-select v-model="form.healthStatus" style="width: 100%" placeholder="请选择健康状态"
                :disabled="model === 'view'">
                <el-option v-for="item in healthStatusList" :key="item.dictKey" :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="联系电话" prop="tel">
              <el-input clearable :disabled="model === 'view'" v-model="form.tel" placeholder="请输入联系电话"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="其他电话" prop="otherTel">
              <el-input clearable :disabled="model === 'view'" v-model="form.otherTel" placeholder="请输入其他电话"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="护理级别" label-width="110px" prop="careLevel">
              <el-select v-model="form.careLevel" style="width: 100%" placeholder="请选择护理级别"
                :disabled="model === 'view'">
                <el-option v-for="item in careLevelList" :key="item.dictKey" :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="死亡日期" prop="deathTime">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" :disabled="model === 'view'"
                v-model="form.deathTime" type="date" placeholder="请选择死亡日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="自理情况" prop="selfCareCondition">
              <el-select :disabled="model === 'view'" v-model="form.selfCareCondition" placeholder="请选择自理情况"
                style="width: 100%">
                <el-option v-for="item in selfCareConditionList" :key="item.dictKey" :label="item.dictValue"
                  :value="item.dictKey">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" style="display: flex;">
            <el-form-item label="家庭住址" prop="addressId" style="width:50%;">
              <avue-cascader
              placeholder="请选择家庭住址"
              style="width:100%;height: 32px;"
              :disabled="model=='view'"
                v-model="form.addressId"
                :props="regionProps"
                lazy
                :lazy-load="lazyLoad"
                :key="modalKey"
              ></avue-cascader>
              <!-- <el-cascader placeholder="请选择家庭住址" :disabled="model == 'view'" lazy @lazyLoad="lazyLoad"
                v-model="form.addressId" :props="props"></el-cascader> -->
              <!-- <avue-cascader
              placeholder="请选择家庭住址"
              style="width:100%;height: 32px;"
              :disabled="model=='view'"
                v-model="form.addressId"
                :props="regionProps"
                :dic="areaList"
              ></avue-cascader> -->
            </el-form-item>
            <el-form-item label="" label-width="20px" prop="address" style="width:50%;margin-top: 5px;">
              <el-input clearable style="width:100%;height: 32px;" :disabled="model === 'view'" v-model="form.address"
                placeholder="请输入详细地址" maxlength="200"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" style="display: flex;">
            <el-form-item label="户籍住址" prop="domicileAddressId" style="width:50%;">
              <!-- <avue-cascader placeholder="请选择户籍住址" style="width:100%;height: 32px;" :disabled="model == 'view'"
                v-model="form.domicileAddressId" :dic="areaList" :props="regionProps"></avue-cascader> -->
                <avue-cascader
              placeholder="请选择户籍住址"
              style="width:100%;height: 32px;"
              :disabled="model=='view'"
                v-model="form.domicileAddressId"
                :key="modalKey"
                :props="regionProps"
                lazy
                :lazy-load="lazyLoad"
              ></avue-cascader>
            </el-form-item>
            <el-form-item label="" label-width="20px" style="width:50%;margin-top: 5px;" prop="domicileAddress">
              <el-input clearable style="width:100%;height: 32px;" :disabled="model === 'view'"
                v-model="form.domicileAddress" placeholder="请输入详细地址" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <div style="width: 100%;height: 40px;line-height: 40px;text-align: center;color: #409EFF;cursor: pointer;"
            @click="openMore" v-if="!isExpand"><i class="el-icon-caret-bottom"></i>展开</div>
          <span :gutter="24" v-if="isExpand">
            <el-col :span="8">
              <el-form-item label="经办/负责人" label-width="110px" prop="responsiblePersonIdList">
                <avue-input-tree clearable multiple :disabled="model === 'view'" style="width:100%"
                  :props='treeAreaProps' v-model="form.responsiblePersonIdList" placeholder="经办/负责人" type="tree"
                  :dic="userPhoneList">
                </avue-input-tree>
              </el-form-item>
            </el-col>

            <el-col :span="8" style="height: 54px;">
              <el-form-item label="到期预警" prop="expirationAlarmDays">
                <div style="display: flex;height: 54px;">
                  <div style="width:50px">提前</div>
                  <el-input-number :controls="false" :disabled="model === 'view'" v-model="form.expirationAlarmDays"
                    @change="handleChange" :min="0" :max="99999" label="请输入到期预警时间"></el-input-number>
                  <span>天</span>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="预警通知人" label-width="110px" prop="alarmNoticePersonIdList">
                <avue-input-tree clearable multiple :disabled="model === 'view'" style="width:100%"
                  :props='treeAreaProps' v-model="form.alarmNoticePersonIdList" placeholder="请选择预警通知人" type="tree"
                  :dic="userPhoneList">
                </avue-input-tree>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="婚姻状况" prop="maritalStatus">
                <el-select :disabled="model === 'view'" v-model="form.maritalStatus" placeholder="请选择婚姻状况"
                  style="width:100%">
                  <el-option v-for="item in maritalStatusList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="民族" prop="nation">
                <el-input clearable :disabled="model === 'view'" v-model="form.nation" placeholder="请输入民族"
                  maxlength="11"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="宗教信仰" prop="religiousBelief">
                <el-select :disabled="model === 'view'" v-model="form.religiousBelief" placeholder="请选择宗教信仰"
                  style="width:100%">
                  <el-option v-for="item in religiousBeliefList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="血型" prop="bloodType">
                <el-select :disabled="model === 'view'" v-model="form.bloodType" placeholder="请选择血型" style="width:100%">
                  <el-option v-for="item in bloodTypeList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="爱好" prop="hobby">
                <el-input clearable :disabled="model === 'view'" v-model="form.hobby" placeholder="请输入爱好"
                  maxlength="50"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="政治面貌" prop="politicalFeatures">
                <el-select :disabled="model === 'view'" v-model="form.politicalFeatures" placeholder="请选择政治面貌"
                  style="width:100%">
                  <el-option v-for="item in politicalFeaturesList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="退休职业" prop="retiredOccupation">
                <el-select :disabled="model === 'view'" v-model="form.retiredOccupation" placeholder="请选择退休职业"
                  style="width:100%">
                  <el-option v-for="item in retiredOccupationTypeList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="本市户籍" prop="isLocalCity">
                <el-select :disabled="model === 'view'" v-model="form.isLocalCity" placeholder="请选择本市户籍"
                  style="width:100%">
                  <el-option v-for="item in yesNoList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="外地迁入" prop="outMigration">
                <el-select :disabled="model === 'view'" v-model="form.outMigration" placeholder="请选择外地迁入"
                  style="width:100%">
                  <el-option v-for="item in yesNoList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="原居住情况" prop="originalResidence">
                <el-select :disabled="model === 'view'" v-model="form.originalResidence" placeholder="请选择原居住情况"
                  style="width:100%">
                  <el-option v-for="item in originalResidenceList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="家庭人口" prop="familyNum">
                <el-input clearable :disabled="model === 'view'" v-model="form.familyNum" placeholder="请输入家庭人口"
                  maxlength="20"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="劳动能力" prop="laborCapacity">
                <el-select :disabled="model === 'view'" v-model="form.laborCapacity" placeholder="请选择劳动能力"
                  style="width:100%">
                  <el-option v-for="item in laborCapacityList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="性格心理" prop="disposition">
                <el-input clearable :disabled="model === 'view'" v-model="form.disposition" placeholder="请输入性格心理"
                  maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="饮食特点" prop="dietaryCharacteristics">
                <el-input clearable :disabled="model === 'view'" v-model="form.dietaryCharacteristics"
                  placeholder="请输入饮食特点" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="文化程度" prop="educationalLevel">
                <el-select :disabled="model === 'view'" v-model="form.educationalLevel" placeholder="请选择文化程度"
                  style="width:100%">
                  <el-option v-for="item in educationalLevelTypeList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="经济来源" prop="economicSource">
                <el-select :disabled="model === 'view'" v-model="form.economicSource" placeholder="请选择经济来源"
                  style="width:100%">
                  <el-option v-for="item in economicSourceList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="医疗保障" prop="medicalSecurity">
                <el-select :disabled="model === 'view'" v-model="form.medicalSecurity" placeholder="请选择医疗保障"
                  style="width:100%">
                  <el-option v-for="item in medicalSecurityList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="医保卡号" prop="medicalCard">
                <el-input clearable :disabled="model === 'view'" v-model="form.medicalCard" placeholder="请输入医保卡号"
                  maxlength="16"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="档案号" prop="fileNumber">
                <el-input clearable :disabled="model === 'view'" v-model="form.fileNumber" placeholder="请输入档案号"
                  maxlength="20"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :disabled="model === 'view'" placeholder="请输入备注" v-model="form.remark"
                  maxlength="500">
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="头像" prop="avatarPictureUrlList">
                <vUpload :disabled="model === 'view'" :message="'提示：只能上传jgp/png文件，且不大于5MB，数量最多1张'"
                  :types="['jpg', 'png']" :max="5242880" :limit="1" :fileList.sync="form.avatarPictureUrlList">
                </vUpload>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <div class="title">健康登记</div>
            </el-col>
            <el-col :span="8">
              <el-form-item label="视力" prop="sight">
                <el-select :disabled="model === 'view'" v-model="healthForm.sight" placeholder="请选择视力"
                  style="width: 100%">
                  <el-option v-for="item in sightTypeList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="听力" prop="hearing">
                <el-select :disabled="model === 'view'" v-model="healthForm.hearing" placeholder="请选择听力"
                  style="width: 100%">
                  <el-option v-for="item in hearingTypeList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="主治医生" prop="attendingPhysician">
                <el-input clearable :disabled="model === 'view'" v-model="healthForm.attendingPhysician"
                  placeholder="请输入主治医生" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="医院电话">
                <el-input clearable :disabled="model === 'view'" v-model="healthForm.tel" placeholder="请输入医院电话"
                  maxlength="20"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="过敏药物">
                <el-input clearable :disabled="model === 'view'" v-model="healthForm.allergyMedicine"
                  placeholder="请输入过敏药物" maxlength="200"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="主要疾病">
                <el-select :disabled="model === 'view'" collapse-tags v-model="healthForm.majorDisease" multiple
                  placeholder="请选择主要疾病" style="width: 100%">
                  <el-option v-for="item in majorDiseaseTypeList" :key="item.dictKey" :label="item.dictValue"
                    :value="item.dictKey">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="病史">
                <el-input type="textarea" clearable :disabled="model === 'view'" v-model="healthForm.medicalHistory"
                  placeholder="请输入病史" maxlength="500"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <div class="title">体检登记</div>
            </el-col>

            <el-col :span="8">
              <el-form-item label="登记时间">
                <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" :disabled="model === 'view'"
                  v-model="physicalForm.registrationTime" type="date" placeholder="请选择登记时间">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="登记人">
                <el-input clearable :disabled="model === 'view'" v-model="physicalForm.registranter"
                  placeholder="请输入登记人" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="体检医院">
                <el-input clearable :disabled="model === 'view'" v-model="physicalForm.examinationHospital"
                  placeholder="请输入体检医院" maxlength="50"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="体检时间" prop="examinationTime">
                <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" :disabled="model === 'view'"
                  v-model="physicalForm.examinationTime" type="date" placeholder="请选择体检时间">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="16">
              <el-form-item label="体检结果">
                <el-input type="textarea" clearable :disabled="model === 'view'"
                  v-model="physicalForm.examinationResult" placeholder="请输入体检结果" maxlength="100"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="体检附件">
                <!-- <VUploadDrag :disabled="model=='view'" :max="20 * 1024 * 1024" :limit="10" :fileList.sync="physicalForm.examinationPictureUrlList" /> -->
                <VUploadDrag :disabled="model == 'view'" :limit="10" :max="20971520"
                  :fileList.sync="physicalForm.examinationPictureUrlList"></VUploadDrag>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="8">
            <el-form-item label="是否签约" prop="isContract">
              <el-select  :disabled="model==='view'||isContract" v-model="form.isContract"
                placeholder="请选择是否签约"
              style="width:100%">
                <el-option
                  v-for="item in isContractList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="入住状态" prop="occupancyStatus">
              <el-select  :disabled="model==='view'||isContract" v-model="form.occupancyStatus"

                placeholder="请选择入住状态"
              style="width:100%">
                <el-option
                  v-for="item in occupancyStatusList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="签订日期" label-width="110px" prop="signContractTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                 :disabled="model==='view'" v-model="form.signContractTime"
                type="date"
                placeholder="请选择签订日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="入住日期" label-width="110px" prop="signInTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                 :disabled="model==='view'" v-model="form.signInTime"
                type="date"
                placeholder="请选择入住日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同到期日期" label-width="110px" prop="contractExpirationTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                 :disabled="model==='view'" v-model="form.contractExpirationTime"
                type="date"
                placeholder="请选择合同到期日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="退住日期" label-width="110px" prop="dischargeTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                 :disabled="model==='view'" v-model="form.dischargeTime"
                type="date"
                placeholder="请选择退住日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          </span>
        </el-row>
      </el-form>
    </div>
    <div style="width: 100%;height: 40px;line-height: 40px;text-align: center;color: #409EFF;cursor: pointer;"
      @click="openMore" v-if="isExpand"><i class="el-icon-caret-top"></i>收起</div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getAreaExtend, getAreaList } from '../api/nursingManage.js';
// import VUploadDrag from '@/views/components/v-upload-drag';
import VUploadDrag from "@/views/components/v-upload";
import { getDictionary } from '@/api/common.js';
import { setStore } from '@/util/store';
import { getStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  saveBasicInfo,
  getNursinghome,
  getBasicInforDetail,
  getUserPhoneList
} from '../api/serveItemManage';
import vUpload from "../components/mutil-upload.vue"
import dayjs from 'dayjs';
export default {
  components: { vUpload, VUploadDrag },
  // model: {
  //   prop: 'form',
  //   event: 'change',
  // },
  props: {
    isBed: {
      default: false,
    },
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      isExpand: false,// 展开/收起
      regionProps: {
        label: 'title',
        value: 'id',
      },
      modalKey: 0,
      healthForm: {
        sight: '',
        hearing: '',
        attendingPhysician: '',
        tel: '',
        allergyMedicine: '',
        medicalHistory: '',
        majorDisease: []
      },
      physicalForm: {
        registrationTime: '',
        registranter: '',
        examinationHospital: '',
        examinationTime: '',
        examinationResult: '',
        examinationPictureUrlList: []
      },
      form: {
        nursinghomeId: '',
        name: "",
        categoryTagList: [],
        serviceNeedTagList: [],
        // signContractTime:'',
        // contractExpirationTime:'',
        responsiblePersonIdList: [],
        expirationAlarmDays: "",
        alarmNoticePersonIdList: [],
        isExistence: "",
        healthStatus: '',
        careLevel: '',
        selfCareCondition: '',
        deathTime: '',
        birthday: "",
        age: '',
        idNumber: "",
        sex: '1',
        tel: "",
        otherTel: '',
        maritalStatus: '',
        nation: "",
        bloodType: '',
        politicalFeatures: "",
        retiredOccupation: '',
        isLocalCity: "",
        outMigration: '',
        originalResidence: '',
        familyNum: '',
        addressId: [],
        domicileAddressId: [],
        address: '',
        domicileAddress: "",
        religiousBelief: '',
        hobby: "",
        disposition: "",
        dietaryCharacteristics: "",
        educationalLevel: "",
        laborCapacity: "",
        economicSource: "",
        medicalSecurity: "",
        medicalCard: "",
        fileNumber: "",
        disposition: "",
        avatarPictureUrlList: [],
        remark: '',

      },
      isExistenceList: [
        {
          id: '1',
          name: '在世'
        },
        {
          id: '0',
          name: '死亡'
        }
      ],
      healthStatusList: [],
      careLevelList: [],
      selfCareConditionList: [],
      areaList: [],
      sightTypeList: [],
      hearingTypeList: [],
      majorDiseaseTypeList: [],
      treeAreaProps: {
        labelText: '标题',
        label: 'namePhone',
        value: 'id',
        children: 'children',
      },
      userPhoneList: [],
      occupancyStatusList: [],
      categoryTagsList: [],
      needTagsList: [],
      projectList: [],
      sexList: [],
      nationData: [
        { id: 1, name: '汉族' },
        { id: 2, name: '蒙古族' },
        { id: 3, name: '回族' },
        { id: 4, name: '藏族' },
        { id: 5, name: '维吾尔族' },
        { id: 6, name: '苗族' },
        { id: 7, name: '彝族' },
        { id: 8, name: '壮族' },
        { id: 9, name: '布依族' },
        { id: 10, name: '朝鲜族' },
        { id: 11, name: '满族' },
        { id: 12, name: '侗族' },
        { id: 13, name: '瑶族' },
        { id: 14, name: '白族' },
        { id: 15, name: '土家族' },
        { id: 16, name: '哈尼族' },
        { id: 17, name: '哈萨克族' },
        { id: 18, name: '傣族' },
        { id: 19, name: '黎族' },
        { id: 20, name: '傈僳族' },
        { id: 21, name: '佤族' },
        { id: 22, name: '畲族' },
        { id: 23, name: '高山族' },
        { id: 24, name: '拉祜族' },
        { id: 25, name: '水族' },
        { id: 26, name: '东乡族' },
        { id: 27, name: '纳西族' },
        { id: 28, name: '景颇族' },
        { id: 29, name: '柯尔克孜族' },
        { id: 30, name: '土族' },
        { id: 31, name: '达翰尔族' },
        { id: 32, name: '么佬族' },
        { id: 33, name: '羌族' },
        { id: 34, name: '布朗族' },
        { id: 35, name: '撒拉族' },
        { id: 36, name: '毛南族' },
        { id: 37, name: '仡佬族' },
        { id: 38, name: '锡伯族' },
        { id: 39, name: '阿昌族' },
        { id: 40, name: '普米族' },
        { id: 41, name: '塔吉克族' },
        { id: 42, name: '怒族' },
        { id: 43, name: '乌孜别克族' },
        { id: 44, name: '俄罗斯族' },
        { id: 45, name: '鄂温克族' },
        { id: 46, name: '德昂族' },
        { id: 47, name: '保安族' },
        { id: 48, name: '裕固族' },
        { id: 49, name: '京族' },
        { id: 50, name: '塔塔尔族' },
        { id: 51, name: '独龙族' },
        { id: 52, name: '鄂伦春族' },
        { id: 53, name: '赫哲族' },
        { id: 54, name: '门巴族' },
        { id: 55, name: '珞巴族' },
        { id: 56, name: '基诺族' },
      ],
      contentStyle: '',
      formRules: {
        // occupancyStatus: [{ required: true, message: '入住状态不能为空', trigger: 'change' }],
        categoryTagList: [{ required: true, message: '老人分类不能为空', trigger: 'blur' }],
        // isContract: [{ required: true, message: '是否签约不能为空', trigger: 'change' }],
        // serviceNeedTagList: [{ required: true, message: '服务需求不能为空', trigger: 'blur' }],
        nursinghomeId: [{ required: true, message: '服务网点不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '老人名称不能为空', trigger: 'blur' }],
        addressId: [{ required: true, message: '家庭住址不能为空', trigger: 'blur' }],
        address: [{ required: true, message: '详细地址不能为空', trigger: 'blur' }],
        tel: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        birthday: [{ required: true, message: '出生日期不能为空', trigger: 'change' }],
        age: [{ required: true, message: '年龄不能为空', trigger: 'change' }],
        idNumber: [{ required: true, message: '身份证号不能为空', trigger: 'change' }],
        // signContractTime: [{ required: false, message: '签订日期不能为空', trigger: 'change' }],
        isExistence: [{ required: true, message: '生存状态不能为空', trigger: 'change' }],
        sex: [{ required: true, message: '性别不能为空', trigger: 'change' }],
        healthStatus: [{ required: true, message: '健康状态不能为空', trigger: 'change' }],
        // contractExpirationTime: [{ required: false, message: '合同到期日期不能为空', trigger: 'change' }],
        deathTime: [{ required: false, message: '死亡日期不能为空', trigger: 'change' }],
        personnelCategory: [{ required: true, message: '人员类别不能为空', trigger: 'change' }],
      },
      matetialList: [],
      maritalStatusList: [],
      economicSourceList: [],
      bloodTypeList: [],
      educationalLevelTypeList: [],
      retiredOccupationTypeList: [],
      politicalFeaturesList: [],
      yesNoList: [],
      originalResidenceList: [],
      personnelCategoryList: [],
      religiousBeliefList: [],
      laborCapacityList: [],
      medicalSecurityList: [],
      nursinghomeIdList: []
    };
  },
  created() {
    if (this.model === 'add') {
      this.form = this._.cloneDeep({
        nursinghomeId: this.form.nursinghomeId,
        name:'',
        birthday:''
      });
    }
    this.initData();
  },
  mounted() {
    this.calcHeight();
    var relativeTime = require('dayjs/plugin/relativeTime')
    // import AdvancedFormat from 'dayjs/plugin/advancedFormat' // ES 2015

    dayjs.extend(relativeTime)
  },
  watch: {

    // "form.isContract"(val){
    //   if(val=="1"){
    //     this.formRules.signContractTime[0].required = true;
    //     this.formRules. contractExpirationTime[0].required = true;
    //   }else{
    //     this.formRules.signContractTime[0].required = false;
    //     this.formRules. contractExpirationTime[0].required = false;
    //   }
    // },
    // "form.occupancyStatus"(val){
    //   if(val==3){
    //     this.formRules.dischargeTime[0].required = true;

    //   }else{
    //     this.formRules.dischargeTime[0].required = false;

    //   }
    //   if(val==1){
    //     this.formRules.signInTime[0].required = true;

    //   }else{
    //     this.formRules.signInTime[0].required = false;

    //   }
    // },
    "form.isExistence"(val) {
      if (val == 0) {
        this.formRules.deathTime[0].required = true;

      } else {
        this.formRules.deathTime[0].required = false;

      }
    },
    "form.categoryTagList"(val) {
      if (!Array.isArray(val)) {
        return;
      }
      if (val.indexOf("6") > -1) {
        this.form.isContract = "1"
        this.form.occupancyStatus = "1"
        this.isContract = true
      } else {
        this.isContract = false
      }
      console.log(val, "----");
      console.log(val, val.indexOf("6"));
    }
  },
  methods: {
    // isContractFlag(){
    //   return this.form.isContract==1
    // },

    birthdayChange(val) {
      let dateNow = this.dayjs(new Date());
      console.log("birthdayChange===========>", dateNow.diff(val, 'year'));
      this.form.age = dateNow.diff(val, 'year');
      this.form = this._.cloneDeep(this.form);
    },
    getGenderByIdNumber(idNumber) {
      if (idNumber) {
        let genderCode; // 性别代码
        if (idNumber.length == 18) {
          // 二代身份证号码长度为18位（第17位为性别代码）
          genderCode = idNumber.charAt(16);
        } else if (idNumber.length == 15) {
          // 一代身份证号码长度为15位（第15位为性别代码）
          genderCode = idNumber.charAt(14);
        }
        if (genderCode && !isNaN(genderCode)) {
          // 两代身份证号码的性别代码都为男奇女偶
          if (parseInt(genderCode) % 2 == 0) {
            return 'female';
          }
          return 'male';
        }
      }
    },

    lazyLoad(node, resolve) {
      let stop_level = 4;
      let level = node.level;
      let data = node.data || {}
      // let code = data.code;
      let list = [];
      let callback = () => {
        resolve((list || []).map(ele => {
          return Object.assign(ele, {
            leaf: level >= stop_level
          })
        }));
      }

      if (level == 0) {
        getAreaExtend().then((res) => {
          list = res.data
          callback()
        });
      } else {
        getAreaExtend({ parentId: node.data.id }).then((res) => {
          list = res.data
          callback()
        });
      }
    },

    async initData() {
      getAreaList().then((res) => {
        this.areaList = res.data;
      });
      console.log(this.form, this.model)
      getProjectList().then((res) => {
        this.projectList = res.data;
      });

      getDictionary('nursinghome_health_status_type').then((res) => {
        this.healthStatusList = res.data;
      })
      getDictionary('nursinghome_care_level').then((res) => {
        this.careLevelList = res.data;
      })
      getDictionary('nursinghome_elderly_category_tag').then((res) => {
        this.categoryTagsList = res.data;
      })
      getDictionary('nursinghome_service_need_tag').then((res) => {
        this.needTagsList = res.data;
      })
      getDictionary('nursinghome_marital_status_type').then((res) => {
        this.maritalStatusList = res.data;
      })
      getDictionary('nursinghome_economic_source_type').then((res) => {
        this.economicSourceList = res.data;
      })
      getDictionary('nursinghome_blood_type').then((res) => {
        this.bloodTypeList = res.data;
      })
      getDictionary('nursinghome_educational_level_type').then((res) => {
        this.educationalLevelTypeList = res.data;
      })
      getDictionary('nursinghome_retired_occupation_type').then((res) => {
        this.retiredOccupationTypeList = res.data;
      })
      getDictionary('nursinghome_political_features_type').then((res) => {
        this.politicalFeaturesList = res.data;
      })
      getDictionary('yes_no').then((res) => {
        this.yesNoList = res.data;
      })
      getDictionary('nursinghome_original_residence_type').then((res) => {
        this.originalResidenceList = res.data;
      })
      getDictionary('nursinghome_personnel_category_type').then((res) => {
        this.personnelCategoryList = res.data;
      })
      getDictionary('nursinghome_religious_belief_type').then((res) => {
        this.religiousBeliefList = res.data;
      })
      getDictionary('nursinghome_labor_capacity_type').then((res) => {
        this.laborCapacityList = res.data;
      })
      getDictionary('nursinghome_medical_security_type').then((res) => {
        this.medicalSecurityList = res.data;
      })
      getDictionary('sex').then((res) => {
        this.sexList = res.data;
      });
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });
      getDictionary('nursinghome_self_care_type').then((res) => {
        this.selfCareConditionList = res.data;
      });
      getDictionary('nursinghome_sight_type').then((res) => {
        this.sightTypeList = res.data;
      });
      getDictionary('nursinghome_hearing_type').then((res) => {
        this.hearingTypeList = res.data;
      });
      getDictionary('nursinghome_major_disease_type').then((res) => {
        this.majorDiseaseTypeList = res.data;
      });
      if (this.model === 'add') {
        this.form.nursinghomeId = this.row.nursinghomeId
        getUserPhoneList({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
          this.userPhoneList = res.data
        })
        this.form.expirationAlarmDays = 30
        if (getStore({ name: 'elderId' })) {
          getBasicInforDetail({ id: getStore({ name: 'elderId' }) }).then(res => {
            console.log("getBasicInforDetail========>", res.data);
            this.form = res.data;
          })
        }

      } else {
        console.log(this.form, "getBasicInforDetail==========>");
        getUserPhoneList({ nursinghomeId: this.row.nursinghomeId }).then((res) => {
          this.userPhoneList = res.data
        })
        getBasicInforDetail({ id: this.isBed ? this.row.liveUserId : this.row.id }).then(res => {
          this.form = res.data;
          this.healthForm = this.form.nursinghomeHealth || {}
          this.physicalForm = this.form.nursinghomePhysical || {}
          // this.form = res.data;
          this.form.addressId = this.form.addressId == "" ? [] : this.form.addressId.split(',');
          this.form.domicileAddressId = this.form.domicileAddressId == "" ? [] : this.form.domicileAddressId.split(',');
          this.healthForm.majorDisease = this.healthForm.majorDisease == "" ? [] : this.healthForm.majorDisease.split(',');
          console.log(this.form, "getBasicInforDetail==========>");
          this.modalKey++
        })
      }
    },
    calcHeight() {
      let bodyHight = document.body.clientHeight;
      let contentHeight = bodyHight - 340;
      this.contentStyle =
        'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;scrollbar-width:none;padding:0 20px';
    },
    openMore() {
      this.isExpand = !this.isExpand;
    },
    saveRecord(cb) {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
        console.log(this.form);
        let obj = Object.assign({}, this.form)
        let healobj = Object.assign({}, this.healthForm)
        let physicalobj = Object.assign({}, this.physicalForm)
        obj.addressId = obj.addressId && obj.addressId.length > 0 ? obj.addressId.join(',') : ''
        obj.domicileAddressId = obj.domicileAddressId && obj.domicileAddressId.length > 0 ? obj.domicileAddressId.join(',') : ''
        healobj.majorDisease = healobj.majorDisease && healobj.majorDisease.length > 0 ? healobj.majorDisease.join(',') : ''
        console.log(obj);
        obj.nursinghomeHealth = healobj
        obj.nursinghomeHealth = healobj
        obj.nursinghomePhysical = physicalobj
        if (result) {
          saveBasicInfo({ id: getStore({ name: 'elderId' }), ...obj }).then((res) => {
            this.$message.success('操作成功！', res);
            this.$emit('success', obj);
            setStore({
              name: 'elderId',
              content: res.data
            })
            if (cb) cb();

          });
        }
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}

.title {
  line-height: 50px;
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
